export function classifyDawdle(minutes, warnMinutes, alertMinutes) {
    if (alertMinutes < warnMinutes) {
        throw new Error(`Invalid thresholds: alertMinutes (${alertMinutes}) must be >= warnMinutes (${warnMinutes})`);
    }
    if (minutes <= 0)
        return 'none';
    if (minutes < warnMinutes)
        return 'green';
    if (minutes < alertMinutes)
        return 'orange';
    return 'red';
}
//# sourceMappingURL=dawdle.js.map